require('./bootstrap');

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { initSentry } from './sentry'

createInertiaApp({
    progress: { color: '#4B5563' },
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {

        const app = createApp({ render: () => h(App, props) })
            .use(plugin)

        initSentry(app)

        app.mount(el)
    },
})

